import { appEnv } from '@/app/config/env';
import { reportsClient } from '@/app/libs';

export async function getFileByName(name: string): Promise<string | null> {
  try {
    const response = await reportsClient.get<{ link: string }>(
      `/arquivo/${appEnv.bucketPdf}/${name}.pdf`,
    );

    return response.link;
  } catch {
    return null;
  }
}
